var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fade-animation"},[_c('h2',{key:_vm.remountText,ref:"animation-text",staticClass:"fade-animation__text",style:('animation-duration:' + _vm.duration + 'ms'),domProps:{"innerHTML":_vm._s(_vm.selectedText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }